nsr.config(['$stateProvider', function($stateProvider) {
    $stateProvider
        .state('admin-vint-manage',
            simpleState("/admin/vint-manage", 'operator-panel/partials/vint/manage.html', 'AdminVintController')
                .subView('admin-vint.account-edit', 'operator-panel/partials/vint/account.html', 'AdminVintAddAccountController')
                .subView('admin-vint.account-buy-shares', 'operator-panel/partials/vint/account-buy-shares.html', 'AdminVintBueSharesController')
                .subView('admin-vint.collection-edit', 'operator-panel/partials/vint/collection-edit.html', 'AdminVintCollectionEditController')
        );
}]);